// extracted by mini-css-extract-plugin
module.exports = {"Navigation":"style_Navigation__Sb8C5","List":"style_List__3gWhg"};